import React from 'react';

import Icon from '../../../components/AppIcon';

const MonthSelector = ({ selectedMonth, onMonthChange }) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const currentDate = new Date();
  const currentYear = currentDate?.getFullYear();
  const currentMonthIndex = currentDate?.getMonth();

  const handlePrevMonth = () => {
    const newIndex = selectedMonth === 0 ? 11 : selectedMonth - 1;
    onMonthChange(newIndex);
  };

  const handleNextMonth = () => {
    const newIndex = selectedMonth === 11 ? 0 : selectedMonth + 1;
    onMonthChange(newIndex);
  };

  const isCurrentMonth = selectedMonth === currentMonthIndex;

  return (
    <div className="flex items-center justify-between bg-card rounded-lg p-16 md:p-20 lg:p-24 shadow-elevation-2">
      <button
        onClick={handlePrevMonth}
        className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted hover:bg-primary/10 transition-smooth active:scale-press min-h-[44px] min-w-[44px]"
        aria-label="Previous month"
      >
        <Icon name="ChevronLeft" size={20} color="var(--color-foreground)" />
      </button>
      <div className="flex flex-col items-center">
        <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-card-foreground">
          {months?.[selectedMonth]} {currentYear}
        </h2>
        {isCurrentMonth && (
          <span className="text-xs md:text-sm text-primary font-caption mt-4">
            Current Month
          </span>
        )}
      </div>
      <button
        onClick={handleNextMonth}
        className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted hover:bg-primary/10 transition-smooth active:scale-press min-h-[44px] min-w-[44px]"
        aria-label="Next month"
      >
        <Icon name="ChevronRight" size={20} color="var(--color-foreground)" />
      </button>
    </div>
  );
};

export default MonthSelector;